// JavaScript: Intersection Observer
if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const iframe = entry.target;
        iframe.src = iframe.dataset.src;
        io.unobserve(iframe);
      });
    }, { rootMargin: '200px' });
  
    document.querySelectorAll('iframe.lazy-yt').forEach(el => {
      io.observe(el);
    });
  } else {
    // フォールバック: ページロード時に全て読み込む
    document.querySelectorAll('iframe.lazy-yt').forEach(el => {
      el.src = el.dataset.src;
    });
  }
  